import { InfoAds } from "../components/common/adverts/infoAds";

export function formatContent(content) {
	const {bannerSection, blockQuoteSection, contactFormSection, contactSection, mainBannerSection, mediaSection,
		membersSection, servicesBlockSection, servicesBulletPointsSection, servicesIconsSection,
		servicesDescriptionSection, sliderSection, textSectionOne, textSectionTwo, textSectionThree, corporateBanner,corporateInformation, corporateContactDetails, corporateTeamMembers } = content;
		let settings = formatSettings(content.settings);
	return {
		bannerSection: bannerSection && {
			content: {
				backgroundImage: bannerSection.backgroundImage.url,
				backgroundColor: bannerSection.backgroundColour,
				button: bannerSection.options.hasContent.hasButton && {
					label: bannerSection.content.button.label,
					link: bannerSection.content.button.url,
					color: settings.colors.primaryColor,
					textColor: settings.colors.primaryTextColor,
				},
				heading: bannerSection.options.hasContent.hasHeading && bannerSection.content.heading,
				subHeading: bannerSection.options.hasContent.hasSubHeading && bannerSection.content.subHeading,
				textColor: bannerSection.content.textColour && bannerSection.content.textColour
			},
			options: {
				layout: bannerSection.options.layout,
				hasButton: bannerSection.options.hasContent.hasButton,
				hasHeading: bannerSection.options.hasContent.hasHeading,
				hasSubHeading: bannerSection.options.hasContent.hasSubHeading,
			},
		},
		blockQuoteSection: blockQuoteSection && {
			author: blockQuoteSection.AuthorsName.hasAuthorsName && blockQuoteSection.AuthorsName.text,
			additionalText: blockQuoteSection.additionalOptions.hasAdditionalInformation && blockQuoteSection.additionalOptions.text,
			content: blockQuoteSection.text,
			color: settings.colors.primaryColor,
			textColor: settings.colors.primaryTextColor,
		},
		contactDetailsSection: contactSection && {
			options: contactSection.options,
			sectionHeading: contactSection.sectionHeading && contactSection.sectionHeading,
			address: contactSection.addressModule.address && {
				subHeading: contactSection.addressModule.subHeading,
				firstLine: contactSection.addressModule.address.firstLine,
				secondLine: contactSection.addressModule.address.secondLine,
				city: contactSection.addressModule.address.city,
				postcode: contactSection.addressModule.address.postcode,
				expand: contactSection.addressModule.address.expand,
			},
			contactDetails: contactSection.contactDetailsModule.contactDetails && {
				subHeading: contactSection.contactDetailsModule.subHeading,
				contactEmail: contactSection.contactDetailsModule.contactDetails[0].contactEmail.hasEmail &&
				contactSection.contactDetailsModule.contactDetails[0].contactEmail.emailAddress,
				contactName: contactSection.contactDetailsModule.contactDetails[0].contactName.hasName &&
				contactSection.contactDetailsModule.contactDetails[0].contactName.contact_name,
				contactPhone: contactSection.contactDetailsModule.contactDetails[0].contactPhone.hasPhone &&
				contactSection.contactDetailsModule.contactDetails[0].contactPhone.phoneNumber
			},
			socialMedia: contactSection.socialMediaModule.socialMedia && {
				subHeading: contactSection.socialMediaModule.subHeading,
				details: formatSocialMedia(contactSection.socialMediaModule.socialMedia)
			}
		},
		contactFormSection: contactFormSection && {
			destinationEmailAddress: contactFormSection.destinationEmailAddress,
			backgroundColor: contactFormSection.formBackgroundColor,
			button: {
				label: contactFormSection.button.label,
				primaryColor: settings.colors.primaryColor,
				secondaryColor: settings.colors.secondaryColor,
				textColor: settings.colors.primaryTextColor
			},
			description: contactFormSection.descriptionText,
			fields: formatContactFormFields(contactFormSection.fieldAdd),
			source: contactFormSection.source
		},
		mainBannerSection: mainBannerSection && {
            backgroundImageDs: mainBannerSection.backgroundChoice.chooseImage && mainBannerSection.backgroundChoice.backgroundImage,
			backgroundImageMb: mainBannerSection.backgroundChoice.chooseImage && mainBannerSection.backgroundChoice.backgroundImageMobile,
			backgroundColor: mainBannerSection.backgroundChoice.chooseColor && mainBannerSection.backgroundChoice.backgroundColour,
			button: mainBannerSection.buttonOptions.hasButton && {
				label: mainBannerSection.buttonOptions.button.label,
				link: mainBannerSection.buttonOptions.button.url,
				color: settings.colors.primaryColor,
				textColor: settings.colors.primaryTextColor,
			},
			logo: mainBannerSection.videoOrLogo === 'Logo' &&  mainBannerSection.logo.url,
			size: mainBannerSection.size,
			tagline: mainBannerSection.taglineOptions.hasTagline && mainBannerSection.taglineOptions.tagline,
			title: mainBannerSection.title,
			videoOrLogo: mainBannerSection.videoOrLogo,
			video: mainBannerSection.videoOrLogo === 'Video' && mainBannerSection.video,
		},
		mediaSection: mediaSection && {
			heading: mediaSection.options.hasHeading && mediaSection.content.heading,
            descriptionRich: mediaSection.options.hasDescription && mediaSection.content.descriptionRich,
			button: mediaSection.options.hasButton && {
				label: mediaSection.content.button.label,
				link: mediaSection.content.button.url,
				color: settings.colors.secondaryColor,
				textColor: settings.colors.secondaryTextColor
			},
			video: mediaSection.media.attach_media === "Video" &&  mediaSection.media.video,
			image: mediaSection.media.attach_media === "Image" &&  mediaSection.media.image,
		},
		memberSection: membersSection && {
			heading: membersSection.headingText,
			description:membersSection.sectionDescription,
			members: formatMembersSection(membersSection.add_members)
		},
		settings: settings,
		servicesBlockSection: servicesBlockSection && {
			services: formatServicesBlockSection(servicesBlockSection.block, servicesBlockSection.options, settings.colors)
		},
		servicesIconsSection: servicesIconsSection && {
			services: formatServicesIconsSection(servicesIconsSection),
			color: settings.colors.secondaryColor,
			textColor: settings.colors.secondaryTextColor,
			heading: servicesIconsSection.servicesIconHeading

		},
		servicesDescriptionSection: servicesDescriptionSection && {
			header: servicesDescriptionSection.heading,
			introduction: servicesDescriptionSection.text,
			linkColor: settings.colors.primaryColor,
			services: formatServicesDescriptionSection(servicesDescriptionSection.servicesGroup)
		},
		servicesBulletedSection: servicesBulletPointsSection && {
			heading: servicesBulletPointsSection.heading,
			description: servicesBulletPointsSection.textDescription,
			bulletListOne: servicesBulletPointsSection.bulletListOne,
			bulletListTwo: servicesBulletPointsSection.bulletListTwo,
			bulletListThree: servicesBulletPointsSection.bulletListThree
		},
		sliderSection: sliderSection && {
			images: formatSliderSection(sliderSection.sliderSection)
		},
		textSectionOne: textSectionOne && {
			columns: textSectionOne.textSection.columns && textSectionOne.textSection.columns
		},
		textSectionTwo: textSectionTwo && {
			columns: textSectionTwo.textSection.columns && textSectionTwo.textSection.columns
		},
		textSectionThree: textSectionThree && {
			columns: textSectionThree.textSection.columns && textSectionThree.textSection.columns
        },
        corporateBanner: corporateBanner && {
            backgroundColor: corporateBanner.backgroundColor && corporateBanner.backgroundColor,
            businessName: corporateBanner.businessName && corporateBanner.businessName,
            businessNameColor: corporateBanner.businessNameTextColor && corporateBanner.businessNameTextColor,
            logo: corporateBanner.logo &&  corporateBanner.logo,
            links: corporateBanner.links ? formatLinks(corporateBanner.links) : null,
            email: corporateBanner.email && corporateBanner.email,
            linkColor: corporateBanner.linkColour && corporateBanner.linkColour
        }, 
        corporateInfo: corporateInformation && {
            corporateInfo: corporateInformation.displayBusinessInformation ? corporateInformation.businesInformation : null
        },
        corporateContact: corporateContactDetails && {
            corporateAddress: corporateContactDetails.displayContactDetails ? corporateContactDetails.address : null,
            mobileNumber:  corporateContactDetails.displayContactDetails ? corporateContactDetails.mobileNumber : null
        },
        corporateMembers: corporateTeamMembers && {
            corporateMembers: corporateTeamMembers.displayTeamMembers ? formatMembers(corporateTeamMembers.teamMembers) : null
        }
	};
}
function formatMembers(data) {
    let completedObject, formatted = [];

    data.map((members) => {
        completedObject ={
            url: members.photo,
            name: members.name,
            jobTitle: members.jobTitle
        }
        formatted.push(completedObject);
    })
    return formatted;
}
    
function formatLinks(data) {
    let completeObject, formatted = [];

    data.map((links) => {
        completeObject = {
            linkType: links.linkType,
            linkUrl: links.linkUrl
        };
        formatted.push(completeObject);
    })
    return formatted;
}

function formatContactFormFields(data) {
	let completeObject, formatted = [];

	data.map((field) => {
		completeObject = {
			label: field.labelText,
			placeholder: field.placeholderText,
			type: field.type
		};
		formatted.push(completeObject);
	});
	return formatted;
}

function formatMembersSection(data) {
	let completeObject, formatted = [];
	data.map((member) => {
		completeObject = {
			header: member.nameMember,
			icon:member.imageMember,
			description: member.descriptionMember,
		};
		formatted.push(completeObject)
	});
	return formatted;
}

function formatSocialMedia(data) {
	let completeObject, formatted = [];
	data.map((socialMedia) => {
		completeObject = {
			socialAccount: socialMedia.account.socialAccount,
			username: socialMedia.account.username,
			url: socialMedia.account.url //refactor for individual accounts
		};
		formatted.push(completeObject);
	});
	return formatted;

}

function formatServicesBlockSection(services, options, colorSettings) {
	let completeObject, formatted = [];

	services.map((service) => {
		completeObject = {
			heading: options.hasHeading && service.heading,
			text:  options.hasDescription && service.text,
			image: service.image.hasImage && service.image.imageUrl,
			button: service.button.hasButton && {
				label: service.button.button.label,
				link: service.button.button.url && service.button.button.url,
				color: colorSettings.secondaryColor,
				textColor: colorSettings.secondaryTextColor
			},
			blockBackgroundColor: service.blockBackgroundColor,
			blockTextColor: service.blockTextColor
		};
		formatted.push(completeObject);
	});
	return formatted;
}

function formatServicesIconsSection(services) {
	let formatted = [];
	for(let i = 0; i < services.service.length; i++)
		formatted.push( {
			button: services.settings.button && {
				link: services.service[i].button.url,
				label: services.service[i].button.label
			},
			image: services.settings.image && services.service[i].image,
			text: services.settings.text && services.service[i].text
		});
	return formatted;
}

function formatServicesDescriptionSection(services) {
	let formatted = [];

	for(let i = 0; i < services.length; i++) {

	  let detailsFormatted = [];
	  let completeObject = {};

		completeObject.description = services[i].summary.description;
		completeObject.title = {
			titleText: services[i].summary.serviceTitle.titleText,
			url: services[i].summary.serviceTitle.url
		};

		if (services[i].summary.details.length) {

			for (let j = 0; j < services[i].summary.details.length; j++) {


				detailsFormatted.push({
					detailLabel: services[i].summary.details[j].detailLabel,
					detail: services[i].summary.details[j].detailItem
				})
			}
		}

		completeObject.details = detailsFormatted;

		formatted.push(completeObject);
	}

	return formatted;
}

function formatSettings(settings) {
	return {
		colors: settings && {	
			primaryColor: settings.primaryColour && settings.primaryColour,
			primaryTextColor: settings.primaryTextColor && settings.primaryTextColor,
			secondaryColor: settings.secondaryColour && settings.secondaryColour,
			secondaryTextColor: settings.secondaryTextColor && settings.secondaryTextColor,
		},
		partnershipDetails: settings && {
			partnerName: settings.partnerName && settings.partnerName,
			partnerDescription: settings.partnerDescription && settings.partnerDescription,
			partnerLogo: settings.partnerLogo && settings.partnerLogo
		}
	}
}

function formatSliderSection(sliderSection) {
	return sliderSection.map((image) => {
		return image.url
	});
}



// WEBPACK FOOTER //
// src/client/helpers/wordpressHelpers.js